import { Collapse, Descriptions, Tag } from 'antd'
import React from 'react'
import * as RankApi from '../../api/rank/rankApi';

import './CustomerResultCard.scss'
import { NO_DATA, URL_RANK } from '../../env';
import { none_rank } from '../ExportImgFigma';
import { formatPrice } from '../../until';


interface props {
    dataCardCustomer?: RankApi.ISearchCardCustomer
}


const OverViewCardCustomer: React.FC<props> = ({
    dataCardCustomer
}) => {

    const infoCustomer = dataCardCustomer?.infoCustomer
    const nextRankInfo = dataCardCustomer?.nextRankInfo
    return (
        <div className='custom-page-css w-full h-full border rounded overflow-hidden'>
            <div className='custom-page-css w-full bg-096DD9'
                style={{
                    padding: '4px 12px'
                }}
            >
                <span className='custom-page-css w-full  text-white font-regular text-base'

                >
                    Thông tin cá nhân
                </span>
            </div>



            <div className='custom-page-css w-full h-full flex flex-col gap-2'
                style={{
                    padding: '4px 12px'
                }}
            >
                <ItemRender label={'Mã thẻ thành viên'} value={infoCustomer?.codeCard ?? NO_DATA} />
                <ItemRender label={'Mã định danh khách hàng'} value={infoCustomer?.code ?? NO_DATA} />
                <div className="custom-page-css flex items-center justify-between ">
                    <span className="text-344054 font-medium text-sm">
                        Hạng thành viên
                    </span>

                    <div className="custom-page-css flex items-center gap-2">
                        <img
                            src={URL_RANK + infoCustomer?.rankIcon}

                            onError={(e) => { e.currentTarget.src = none_rank }}
                            alt=""
                            className="rank-icon"
                        />
                        <span className='font-regular text-344054  text-sm '>{infoCustomer?.rankTitle}</span>
                    </div>
                </div>
                <ItemRender label={'Ngày phát hành thẻ'} value={infoCustomer?.releaseDate ?? NO_DATA} />
                <ItemRender label={'Ngày hết hạn thẻ'} value={infoCustomer?.expirationDate ?? NO_DATA} />
                <ItemRender label={'Tổng chi tiêu'} value={formatPrice(infoCustomer?.totalAmount) ?? 0} />
                <ItemRender label={'Tổng chi tiêu mua xe'} value={formatPrice(infoCustomer?.totalPurchaseAmount ? infoCustomer?.totalPurchaseAmount : 0)} />
                <ItemRender label={'Tổng chi tiêu dịch vụ'} value={formatPrice(infoCustomer?.totalServiceAmount ? infoCustomer?.totalServiceAmount : 0)} />

            </div>
        </div>
    )
}

export default OverViewCardCustomer

interface ItemRenderProps {
    label: string;
    value?: React.ReactNode;
}

const ItemRender: React.FC<ItemRenderProps> = ({
    label,
    value,
}) => (
    <div className="custom-page-css flex items-center justify-between ">
        <span className="text-344054 font-medium text-sm">
            {label}
        </span>

        <span className="text-344054 font-regular text-sm">
            {value ?? NO_DATA}
        </span>
    </div>
);

